import { connect } from "react-redux";
// import { updateProtocolExample } from "./store/actions";
import { ProtocolChapter as Component } from "./protocolChapter";

/**
 * Maps the Redux store's state to the props that the ProtocolChapter component needs.
 *
 * @param {Object} state - The entire Redux store's state.
 * @param {Object} ownProps - The props that are being passed to the ProtocolChapter component.
 *
 * @returns {Object} Object containing data to be passed as props to the ProtocolChapter component.
 */
const mapStateToProps = () => {
  return {
    //currentWeight: state.electronicScale.currentWeight,
  };
};

const mapDispatchToProps = () => {
  return {
    // Update the protocol chapter example string
  };
};

// Connect the ProtocolChapter component to the Redux store.
export const ProtocolChapter = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
